import React from 'react';

// Shared StayMii platform footer — used across all modules (Lite, e-Invoice,
// e-Ticket, HR) so the mobile/desktop footer is identical everywhere.
export default function PlatformFooter({ className = '' }) {
  return (
    <footer
      className={`shrink-0 text-center space-y-1 py-3 md:py-4 px-4 md:px-6 ${className || 'bg-[#181B30]'}`}
      data-testid="platform-footer"
    >
      <p className="text-[11px] md:text-xs text-gray-400" data-testid="footer-brand">Powered by Mii Global | StayMii Platform</p>
      <p className="text-[10px] md:text-[11px] text-gray-500">&copy; {new Date().getFullYear()} Mii Global Partner Holdings Sdn Bhd (202601028203 (1690298-K)). All rights reserved.</p>
      <p className="text-[9px] md:text-[10px] text-gray-600">StayMii Cloud Hospitality Management Software is a registered copyrighted work in Malaysia. Application No: LY2026E01573</p>
    </footer>
  );
}
